module.exports = __webpack_public_path__ + "img/error.5ebc1d2f.gif";